import React, { useState, useEffect } from "react";
import "./AdminSettings.css";

const AdminSettings = () => {
  const [companyName, setCompanyName] = useState("");
  const [companyLogo, setCompanyLogo] = useState(null);
  const [companyBanner, setCompanyBanner] = useState(null);
  const [previewLogo, setPreviewLogo] = useState("");
  const [previewBanner, setPreviewBanner] = useState("");
  const [themeColor, setThemeColor] = useState("#004aad");

  useEffect(() => {
    // Load saved data (can be replaced with API call)
    const savedName = localStorage.getItem("companyName");
    const savedLogo = localStorage.getItem("companyLogo");
    const savedBanner = localStorage.getItem("companyBanner");
    const savedTheme = localStorage.getItem("themeColor");

    if (savedName) setCompanyName(savedName);
    if (savedLogo) setPreviewLogo(savedLogo);
    if (savedBanner) setPreviewBanner(savedBanner);
    if (savedTheme) setThemeColor(savedTheme);
  }, []);

  const handleLogoChange = (e) => {
    const file = e.target.files[0];
    setCompanyLogo(file);

    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => setPreviewLogo(reader.result);
      reader.readAsDataURL(file);
    }
  };

  const handleBannerChange = (e) => {
    const file = e.target.files[0];
    setCompanyBanner(file);

    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => setPreviewBanner(reader.result);
      reader.readAsDataURL(file);
    }
  };

  const handleColorChange = (e) => {
    const color = e.target.value;
    setThemeColor(color);
    document.documentElement.style.setProperty("--theme-color", color);
  };

  const handleSave = () => {
    localStorage.setItem("companyName", companyName);
    if (previewLogo) localStorage.setItem("companyLogo", previewLogo);
    if (previewBanner) localStorage.setItem("companyBanner", previewBanner);
    localStorage.setItem("themeColor", themeColor);

    document.documentElement.style.setProperty("--theme-color", themeColor);
    alert("✅ Company settings updated successfully!");
  };

  return (
    <div className="settings-container">
      <h2>Company Settings</h2>

      <div className="settings-card">
        <label>Company Name</label>
        <input
          type="text"
          placeholder="Enter company name"
          value={companyName}
          onChange={(e) => setCompanyName(e.target.value)}
        />

        <div className="image-upload">
          <label>Company Logo</label>
          <input type="file" accept="image/*" onChange={handleLogoChange} />
          {previewLogo && (
            <div className="preview">
              <img src={previewLogo} alt="Company Logo" />
            </div>
          )}
        </div>

        <div className="image-upload">
          <label>Company Banner</label>
          <input type="file" accept="image/*" onChange={handleBannerChange} />
          {previewBanner && (
            <div className="preview banner">
              <img src={previewBanner} alt="Company Banner" />
            </div>
          )}
        </div>

        <div className="color-theme">
          <label>Theme Color</label>
          <input
            type="color"
            value={themeColor}
            onChange={handleColorChange}
            className="color-picker"
          />
          <span className="color-preview" style={{ backgroundColor: themeColor }}>
            {themeColor.toUpperCase()}
          </span>
        </div>

        <button
          className="save-btn"
          style={{ backgroundColor: themeColor }}
          onClick={handleSave}
        >
          Save Changes
        </button>
      </div>
    </div>
  );
};

export default AdminSettings;
